import { useMutation } from "@tanstack/react-query";
import { useAuthenticatedRequestCreator } from "hooks/useRequests";
import { ApplicationUser, SilentUser } from "models/applicationUsers";

export interface SilentAccountMergeRequest {
    breaker: ApplicationUser;
    trueUser: SilentUser;
    falseUser: SilentUser;
    dryRun: boolean;
}

export interface SilentAccountMergeResult {
    cardsEffected: number;
    packagesEffected: number;
    transactionsEffected: number;
    dryRun: boolean;
}

export const useSilentAccountMerge = () => {
    const merge = useAuthenticatedRequestCreator<SilentAccountMergeResult, SilentAccountMergeRequest>(
        (req) => ({
            method: 'post',
            url: '/breaker/accounts/merge',
            data: {
                breakerId: req.breaker.id,
                trueAccountId: req.trueUser.accountId,
                toBeDeletedAccountId: req.falseUser.accountId,
                dryRun: req.dryRun
            }
        }), [400, 500]
    );

    const { mutateAsync: mergeAccounts, isLoading } = useMutation(merge);

    return { mergeAccounts, isLoading };
};